import { render, staticRenderFns } from "./DirectEasyLegalDocuments.vue?vue&type=template&id=ab1f682a"
import script from "./DirectEasyLegalDocuments.vue?vue&type=script&lang=js"
export * from "./DirectEasyLegalDocuments.vue?vue&type=script&lang=js"
import style0 from "./DirectEasyLegalDocuments.vue?vue&type=style&index=0&id=ab1f682a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports